




























































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import CouponDiscountForm from '@/modules/common/cart/components/shared/CouponDiscountForm.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AnimateCartField from '@/modules/shared/components/shared/utils/AnimateField.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import { CartPayInformationListModel } from '@/modules/common/cart/models/cart-resource.model'

@Component({
  components: {
    PriceView, AnimateCartField, BaseButton, CouponDiscountForm
  }
})

export default class BaseCart extends Vue {

  @Prop() payInformation!: CartPayInformationListModel[]

  @Prop({ default: 'سبد خرید' }) cartTitle!: string
  @Prop({ default: 'ion cart-outline' }) icon!: string

  @Prop({ default: 'ذخیره و ادامه فرایند' }) nextButtonText!: string
  @Prop({ default: true }) nextButtonEnabled!: boolean
  @Prop() loading!: boolean

  @Prop() backUrl!: string
  @Prop({ default: 'مرحله قبل' }) backButtonLabel!: string

  @Prop({ default: false }) hideSeparator!: boolean

  next() {
    this.$emit('next')
  }

  get stickBottom() {
    return this.$q.screen.lt.md
  }

  get filterPayInformation() {
    return this.stickBottom
      ? this.payInformation.slice(-1)
      : this.payInformation
  }
}
